<script setup>
// Prominent, mobile-only nudge to install the app. The web is a capable
// fallback, but invited users who sign up on their phone (no app yet) get a
// much better experience in the native app — so on small screens this is the
// first thing on the home page, for members and pending applicants alike.
import {APP_STORE} from '~/utils/appLinks';
const APPLE_URL = APP_STORE.ios;
const GOOGLE_URL = APP_STORE.android;
</script>

<template>
  <div class="home-app-cta d-md-none">
    <div class="home-app-cta__head">
      <div class="home-app-cta__icon">
        <v-icon size="26" icon="mdi-cellphone-arrow-down"/>
      </div>
      <div class="home-app-cta__text">
        <div class="home-app-cta__title">Get the Tap Leagues app</div>
        <div class="home-app-cta__sub">
          Live scoring, chat and instant updates, for a smoother experience on your phone.
        </div>
      </div>
    </div>
    <div class="home-app-cta__stores">
      <a :href="APPLE_URL" target="_blank" rel="noopener" aria-label="Download on the App Store">
        <img src="/images/apple_link.png" alt="Download on the App Store"/>
      </a>
      <a :href="GOOGLE_URL" target="_blank" rel="noopener" aria-label="Get it on Google Play">
        <img src="/images/google_link.png" alt="Get it on Google Play"/>
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.home-app-cta {
  background: rgb(var(--v-theme-brandTint));
  border: 1px solid rgb(var(--v-theme-borderLight));
  border-radius: 16px;
  padding: 18px 18px 16px;
  margin-bottom: 20px;

  &__head {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }

  &__icon {
    flex-shrink: 0;
    width: 46px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: rgb(var(--v-theme-surface));
    color: rgb(var(--v-theme-primary));
  }

  &__title {
    font-size: 16px;
    font-weight: 800;
    letter-spacing: -0.3px;
    color: rgb(var(--v-theme-primary));
  }

  &__sub {
    font-size: 12.5px;
    line-height: 1.5;
    color: rgb(var(--v-theme-charcoal));
    margin-top: 3px;
  }

  &__stores {
    display: flex;
    gap: 10px;
    margin-top: 16px;

    a {
      flex: 1;
      display: flex;
      justify-content: center;
    }

    img {
      display: block;
      height: 46px;
      width: auto;
      border-radius: 8px;
    }
  }
}
</style>
